import React from 'react';
import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import environment from '../config/environment';
import { useParams } from 'react-router-dom';
import { FiActivity, FiUsers, FiCalendar, FiDollarSign, FiFile, FiClock } from 'react-icons/fi';
import '../styles/ProjectDashboard.css';
const {
  ProjectStats,
  BudgetOverview,
  TeamMembers,
  UpcomingEvents,
  RecentActivity,
  TaskList,
  ProjectTimeline,
  GoalProgress,
  ResourceAllocation,
  RiskAssessment,
  CommunicationHub,
  QualityMetrics,
  StakeholderUpdates,
  DocumentLibrary
} = require('../components/Dashboard');


const ProjectDashboard = () => {
  const { causeId } = useParams();
  const { user } = useAuth();
  const [causes, setCauses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const { apiUrl } = environment();

  useEffect(() => {
    const fetchCauses = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/causes`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) throw new Error('Failed to fetch causes');
        const data = await response.json();
        setCauses(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching causes:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCauses();
  }, [apiUrl]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  if (!user) return <div>Please login to view this dashboard</div>;
  if (!causeId) return <div>Loading...</div>;

  return (
    <div className="project-dashboard">
      <ProjectStats causeId={causeId} />
      
      <div className="dashboard-nav">
        <button 
          className={`nav-btn ${activeTab === 'overview' ? 'active' : ''}`} 
          onClick={() => handleTabChange('overview')}
        >
          Overview
        </button>
        <button 
          className={`nav-btn ${activeTab === 'documents' ? 'active' : ''}`}
          onClick={() => handleTabChange('documents')}
        >
          Documents
        </button>
        {/* Add other navigation buttons as needed */}
      </div>

      <div className="dashboard-content">
        {activeTab === 'overview' && (
          <>
            {/* Top Stats Row */}
            <div className="dashboard-stats">
              <div className="stat-card">
                <div className="stat-icon money">
                  <FiDollarSign />
                </div>
                <div className="stat-content">
                  <h3>Total Funds</h3>
                  <p>Project Statistics</p>
                </div>
              </div>
              
              <div className="stat-card">
                <div className="stat-icon team">
                  <FiUsers />
                </div>
                <div className="stat-content">
                  <h3>Team Members</h3>
                  <TeamMembers causeId={causeId} />
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon calendar">
                  <FiCalendar />
                </div>
                <div className="stat-content">
                  <h3>Upcoming Events</h3>
                  <UpcomingEvents causeId={causeId} />
                </div>
              </div>
            </div>

            {/* Add BudgetOverview below the stats */}
            <div className="dashboard-section">
              <BudgetOverview causeId={causeId} />
            </div>

            {/* Main Dashboard Grid */}
            <div className="dashboard-grid">
              <div className="dashboard-card activity-feed">
                <RecentActivity causeId={causeId} />
              </div>

              <div className="dashboard-card tasks">
                <TaskList causeId={causeId} />
              </div>

              <div className="dashboard-card budget">
                <BudgetOverview causeId={causeId} />
              </div>

              <div className="dashboard-card timeline">
                <ProjectTimeline causeId={causeId} />
              </div>

              <div className="dashboard-card goals">
                <GoalProgress causeId={causeId} />
              </div>

              <div className="dashboard-card resources">
                <ResourceAllocation causeId={causeId} />
              </div>

              <div className="dashboard-card risks">
                <RiskAssessment causeId={causeId} />
              </div>

              <div className="dashboard-card communication">
                <CommunicationHub causeId={causeId} />
              </div>

              <div className="dashboard-card quality">
                <QualityMetrics causeId={causeId} />
              </div>

              <div className="dashboard-card stakeholders">
                <StakeholderUpdates causeId={causeId} />
              </div>
            </div>
          </>
        )}

        {activeTab === 'documents' && (
          <DocumentLibrary causes={causes} />
        )}

        {/* Add other tab content as needed */}
      </div>
    </div>
  );
};

export default ProjectDashboard; 